/* --- inline script #0 --- */

  // tiny clock - same vibe as the Doom Scroller standalone
  (function() {
    var el = document.getElementById('clock');
    if (!el) return;
    function tick() {
      var d = new Date();
      var h = d.getHours();
      var m = d.getMinutes();
      var s = d.getSeconds();
      var ampm = h >= 12 ? 'PM' : 'AM';
      h = h % 12; if (h === 0) h = 12;
      var pad = function(n) { return n < 10 ? '0' + n : '' + n; };
      el.textContent = h + ':' + pad(m) + ':' + pad(s) + ' ' + ampm;
    }
    tick();
    setInterval(tick, 1000);
  })();
